const config = {
    development: {
      host: '47.128.190.79', // need to change IP of the machine when deploying on aws
      port: 4000,
      // database: {
      //   user: 'devUser',
      //   password: 'devPassword',
      //   name: 'devDatabase'
      // },
      // jwtSecret: "wQsdasdjS"
    },
    production: {
      host: 'diaholic.ai',
      port: 80,
      // database: {
      //   user: 'prodUser',
      //   password: 'prodPassword',
      //   name: 'prodDatabase'
      // },
      // jwtSecret: 'prodSecretKey'
    }
  };
  
  const environment = process.env.NODE_ENV || 'development';
  console.log(process.env.NODE_ENV);
  
  module.exports = config[environment];
